(function() {
  exports.CropYear = (function() {
    function CropYear() {
      this.year = moment().add(5, 'months').add(17, 'days').year();
      return this.year;
    }

    CropYear.prototype.get = function() {
      return this.year;
    };

    return CropYear;

  })();

}).call(this);
